// extracted by mini-css-extract-plugin
module.exports = {"content":"TermsAcknowledgement_content__3pjfn","terms":"TermsAcknowledgement_terms__2H5DJ","rsBtn":"TermsAcknowledgement_rsBtn__3Xj5G"};